import { observer } from "mobx-react-lite"
import { FC, useContext } from "react"
import { Context } from "../.."

import styles from "../../styles/Loyalty/LoyaltyStore.module.scss"
import XPageModal from "../../app/libs/topgun-ui-kit/xmodals/XPageModal"

const MobileAppModal: FC = () => {

  const { loyaltyStore } = useContext(Context)

  return (
    <>
      <XPageModal
        id="mobile_app"
        visible={loyaltyStore.isMAppVisible}
        onClose={() => {
          loyaltyStore.setIsMAppVisible(false)
        }}
        theme="dark"
        activeZone={false}
        title={<><b className="xmtitle">Приложение <strong>ПЛЮС</strong></b></>}
        content={<>
          <div className={styles.objectively}>
            {/* <h4>Как установить или обновить приложение:</h4> */}
          
            {/* <div className={styles.ios_block}>
              <svg width="27" height="33" viewBox="0 0 27 33" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.0081 17.0815C21.9713 13.0237 25.3583 11.0496 25.5132 10.9577C23.595 8.18404 20.6218 7.80508 19.577 7.77486C17.0799 7.51424 14.6577 9.25672 13.3857 9.25672C12.0883 9.25672 10.1294 7.80004 8.01827 7.84285C5.30154 7.8844 2.76001 9.44432 1.3661 11.8667C-1.51058 16.8058 0.63487 24.064 3.39095 28.0564C4.76962 30.0116 6.38061 32.1947 8.48925 32.1179C10.5522 32.0336 11.3228 30.8136 13.8123 30.8136C16.2789 30.8136 17.0025 32.1179 19.153 32.0688C21.367 32.0336 22.7609 30.1048 24.0914 28.1319C25.6846 25.8909 26.3244 23.6838 26.3498 23.5705C26.2978 23.5529 22.05 21.9451 22.0081 17.0815Z"></path>
                <path d="M17.9451 5.14812C19.0547 3.77201 19.8138 1.89986 19.6031 0C17.9972 0.0705049 15.9888 1.10164 14.8323 2.44753C13.8091 3.63352 12.8951 5.57744 13.1312 7.40553C14.9352 7.53899 16.7873 6.50282 17.9451 5.14812Z"></path>
              </svg>
              <span>iOS</span>
            </div> */}

            {/* <p style={{textAlign: "center", marginBottom: "24px"}}>Добавьте иконку web-приложения на экран вашего iPhone для быстрого доступа</p> */}

            {/* <ol className={styles.ol_ios_list}>
              <li>В браузере Safari откройте страницу topgun.plus</li>
              <li>Нажмите на кнопку <b>Поделиться</b></li>
              <li>Выберите <b>«На экран Домой»</b></li>
            </ol> */}

            {loyaltyStore.isMAppVisible ? <video autoPlay={true} muted={true} playsInline={true} controls={false} loop={true} preload="none" style={{
              width: "100%",
              position: "relative",
              top: "-60px"
            }}>
              <source src="/assets/zfgif_new.mp4" type="video/mp4" />
            </video> : <></>}
          </div>
        </>} />
    </>
  )
}

export default observer(MobileAppModal)
